<template>
  <sfs-form-modal
    :id="modalId"
    :title="`Add a ${$store.getters.translate('client', 'Client')}`"
    size="lg"
    @on-hide="resetFormData"
  >
    <clients-form
      :payment_term_days="0"
      :organization="$store.getters.currentOrganization"
      :organization_id="$store.getters.currentOrganization?.id"
      invoice_delivery_method="email"
      @on-submit="createClient"
      @on-save="(client) => $router.push({ name: 'client', params: { id: client.id } })"
      @on-cancel="closeModal"
      :new-form="true"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import ClientsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';
import { CONTACT_INFO_CATEGORY_BILLING_EMAIL } from '@/constants/contactInfos';

export default {
  name: 'ClientsAddModal',
  mixins: [formModalMixin],
  components: {
    ClientsForm,
  },
  data() {
    return {
      modalId: 'client-add-modal',
    };
  },
  methods: {
    createClient(data, handleCreate) {
      const {
        billing_email: billingEmail,
        create_location: createLocation,
        address,
        city,
        state,
        zip_code: zipCode,
        ...clientData
      } = data;

      handleCreate(
        this.$clientsAPI
          .create({ ...clientData, invoice_work_orders_individually: this.$store.getters.isBMSOrganization })
          .then((response) =>
            this.$contactInfosAPI
              .createClientsContactInfos(response.id, {
                content: billingEmail,
                category: CONTACT_INFO_CATEGORY_BILLING_EMAIL,
              })
              .then(() => {
                if (createLocation) {
                  return this.$locationsAPI
                    .create({
                      client_ids: [response.id],
                      name: data.name,
                      store_number: data.code,
                      street: address,
                      city,
                      state,
                      zip_code: zipCode,
                    })
                    .then(() => response);
                }

                return response;
              })
          )
      );
    },
  },
};
</script>
